 /*
              Author: Vaishnavi
              Date: 26/11/2019
              Issue Description: Commented the search bar as it was not required.
            */
<template>
  <div>
    <div class="main-container">
      <div class="nav">
        <span>
          Payroll > Manage paygroups >
          <b>Add Paygroups</b>
        </span>
      </div>
      <tl-header type="h1">
        <div>Pay Groups</div>
        <template slot="icon">
         
        </template>
      </tl-header>
      <div v-if="!payGroupData.length && displayCostCentre">
        <div class="noData">
          <span>
            You have not added any Pay Groups yet.
            <br>Click on Add Paygroup to add get started.
          </span>
        </div>
        <form-add-button main_text="+ Add New" sub_text="Cost Center" @click="createForm()"></form-add-button>
        <div class="download-btn">
          <download-button></download-button>
        </div>
      </div>
      <div v-else>
        <div>
          <div class="row mr-bt-17">
           
            <!-- <div class="col-6">
              <tl-search @change="searchGroup"></tl-search>
            </div> -->
            <div class="col-6 pull-right">
              <div class="row-container">
                <img src="@/assets/group-5.svg" class="Group-5">
                <button
                  class="text-green"
                  @click="$router.push(`/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/addPayGroup`)"
                >Add New PayGroup</button>
              </div>
            </div>
          </div>
          <data-table
            :columns="payGroupDataColumns"
            :tableData="payGroupData"
            :checkbox="true"
            :withForm="false"
            @editStart="initEditStart"
            @delete="deleteItem"
            @update="updateItem"
          />
        </div>
        <form-add-button main_text="+ Add New" sub_text="Cost Center" @click="createForm()"></form-add-button>
        <div class="download-btn">
          <download-button></download-button>
        </div>
        <toast-message :message="errmsg" v-show="toast" type="error"/>
      </div>
      <bottom-action-container class="placeAtEnd">
        <template slot="end">
          <btn text="Continue" type="primary" class v-on:click="continuee"></btn>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState("dashboard/payroll/monthlypayroll/payGroup/", {
      payGroupData: state => state.data
    })
  },
  activated() {
    //console.log("routeParams", this.$route);
  },
  data() {
    return {
      displayCostCentre: true,
      search: "",
      errmsg:"",
      payGroupData: [
        {
          id:1,
          groupName: "Bangalore Employees",
          criteria: "Hebbal",
          totalEmployees: "32"
        },
        {
          id:2,
          groupName: "Bangalore Employees",
          criteria: "Koramangala",
          totalEmployees: "50"
        },
        {
          id:3,
          groupName: "Bangalore Employees",
          criteria: "Hebbal",
          totalEmployees: "38"
        },
        {
          id:4,
          groupName: "Un Group",
          criteria: "Hebbal",
          totalEmployees: "45"
        }
      ],
      payGroupDataColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Description",
          key: "description"
        },
        {
          label: "Criteria",
          key: "criteria"
        },
        {
          label: "Value",
          key: "value"
        }
      ]
    };
  },
  methods: {
    ...mapActions("dashboard/payroll/monthlypayroll/payGroup/", {
      act_delete: "delete",
      act_changeEditMode: "changeEditMode"
    }),
    goToIntro() {
      this.$emit("displayIntro");
    },

    clicknew(payload) {
      this.$emit("clicknew", payload);
    },

    continuee() {
      //   this.$router.push({
      //     path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
      //   });
    },
    disable() {
      //this.$emit("displayIntro");
    },
    enable() {
      this.showButton = false;
      this.displayCostCentre = false;
    },
    cancel() {
      this.displayCostCentre = false;
      this.showButton = false;
    },
    cancelForm() {
      this.showForm = false;
    },
    initCreateForm() {
      this.instance = this.$_.cloneDeep(this.blankInstance);
      this.isFormActive = true;
      this.showButton = false;
    },

    submitForm(payload) {
      this.create(payload);
    },
    submitNewForm(payload) {
      if (this.mode == "edit") {
        this.updateItem(payload);
      } else if (this.mode == "add") {
        this.create(payload);
      }
      this.showForm = false;
    },

    searchGroup(searchText) {
      this.search = searchText;
    },

    // async create(instance) {
    //   //console.log(this.orgId);
    //   try {
    //     await this.act_create(
    //       {
    //         org_id: this.orgId,
    //         legalEntity: this.le_id,
    //         ...instance
    //       },
    //       this.le_id
    //     );
    //     //console.log("added data", instance);
    //     this.resetAndCloseForm();
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err.message;
    //   }
    // },
    async updateItem(item) {
      // try {
      //   await this.act_update([item, this.le_id]);
      //   // //console.log('cost centres updating', res)
      // } catch (err) {
      //   this.toast = true;
      //   this.errmsg = err.message;
      // }
    },
    async deleteItem(item) {
      try {
        await this.act_delete([item, this.le_id]);
        this.displayCostCentre = true;
      } catch (err) {
        this.toast = true;
        //console.log("error msg", err.message);
        this.errmsg = err.message;
      }
    },
    async createForm() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/addPayGroup`
      });
      this.displayCostCentre = false;
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/addPayGroup`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/addPayGroup`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    goToSalaryGradesIntro() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
      });
    }
    // navHandler(navType) {
    //   this.$validator.reset();
    //   if (navType == "back") {
    //     this.$router.push({
    //       path: `/onboarding/entity/${
    //         this.$route.params.entity_index
    //       }/locations`
    //     });
    //   }
    //   if (navType == "next") {
    //     this.$validator.reset();
    //     this.$router.push({
    //       path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
    //     });
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.sep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  /* margin-bottom: 15px; */
}
.main-container {
  width: 100%;
  padding: 20px 15px;
}
.mr-bt-17 {
  margin-bottom: 17px;
}
.row-container {
  justify-content: flex-end;
}
.nav {
  margin-bottom: 1.7%;
  color: #555555;
  font-size: 12px;
}
.pull-right {
  text-align: right;
}
.text-green {
  color: #34c0be;
  font-weight: bold;
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
}
.download-btn {
  margin: 15px 0px;
}
.enable-button {
  width: 13%;
  height: 35px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 2px solid #5d409f;
  color: #5d409f;
  margin-left: 42%;
}
.tablesep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  margin-bottom: 15px;
}

.buttondis {
  margin-left: auto;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.pull-right {
  width: 100%;
  text-align: right;
}

.disablebtn {
  align-items: center;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.top-heading {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 54px;
  background-color: #f5f6fa;

  .spacing {
    margin-left: 10px;
    grid-column-gap: 110%;
  }
}

.top-heading p {
  font-weight: bold;
  margin-top: 16px;
}

.placeAtEnd {
  margin-top: 130px;
}
.showIntro {
  cursor: pointer;
}
p {
  margin-top: 16px;
}
</style>
